<template>
  <WhiteIQOS bodyClass="gap-row-xs" :title="$t('sms_categories.title')">
    <template v-for="(flag, category) in smsCategories">
      <div class="sms-category" :key="category">
        <BaseIcon icon="dot" :class="flag ? 'green-5-color' : 'red-4-color'" size="sm2" />
        <div class="qrw-paragraph-md bold v1-grey-10-color  w-100">
            {{ $t('sms_categories.'+category) }}
        </div>
        <BaseButton @click="goToSetup(category)" variant="secondary" color="v1-grey-10" size="sm">
            {{ $t('sms_categories.btn_setup') }}
        </BaseButton>
      </div>
      <BaseDivider color="v1-grey-4" :key="`d${category}`" v-if="category != 'marketing'"/>
    </template>

    <template #actions>
        <div class="gap-column-xs qrw-paragraph-md bold v1-grey-10-color">
            <div class="gap-column-2xs">
                <BaseIcon icon="dot" :class="'green-5-color'" size="sm2" />
                {{ $t('sms_categories.active') }}
            </div>
            <div class="gap-column-2xs">
                <BaseIcon icon="dot" :class="'red-4-color'" size="sm2" />
                {{ $t('sms_categories.inactive') }}
            </div>
        </div>
    </template>
  </WhiteIQOS>
</template>

<script>
export default {
    methods: {
        goToSetup(key) {
            const routes = {
                'order_status': '/client_app',
                'marketing': '/tools',
                'security': '/settings',
                'pending_orders': '/notifications',
                'customer_verify': '/client_app'
            };

            this.$router.push(routes[key]);
        }
    },
  computed: {
      smsCategories() {
          return {
              order_status: this.cafe.client_app.notifications.enabled && this.cafe.client_app.notifications.channel_sms,
              customer_verify: this.cafe.client_app.verify_client_phone,
              pending_orders: !!this.cafe.order_reminder_timeout && !this.owner.ownersbot_id,
              security: this.owner.two_factor_auth.enabled,
              marketing: true
          }
      },
      cafe() {
          return this.$store.state.cafe;
      },
      owner() {
          return this.$store.state.owner;
      }
  },
};
</script>

<style scoped>
.sms-category {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
}
</style>
